module.exports = __webpack_public_path__ + "static/media/img54.ada0eee5.jpg";